import DOMPurify from 'dompurify';
import { useMemo } from 'react';

const ALLOWED_TAGS = ['b', 'i', 'em', 'strong', 'u', 'p', 'br', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'img', 'blockquote', 'code', 'pre', 'span', 'div', 'hr', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'iframe', 'video', 'source'];
const ALLOWED_ATTR = ['href', 'src', 'alt', 'title', 'target', 'rel', 'class', 'style', 'width', 'height', 'controls', 'autoplay', 'muted', 'loop', 'playsinline', 'frameborder', 'allow', 'allowfullscreen'];

/**
 * Renders sanitized HTML in ad descriptions.
 * Fallback: if the content doesn't contain HTML tags, render as plain text preserving newlines.
 */
export const HtmlContent = ({ html, className = '', dataTestId }) => {
    const clean = useMemo(() => {
        if (!html) return '';
        return DOMPurify.sanitize(String(html), {
            ALLOWED_TAGS,
            ALLOWED_ATTR,
            ADD_ATTR: ['target'],
            FORBID_TAGS: ['script', 'style', 'form', 'input', 'button', 'meta', 'link'],
            FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover'],
        });
    }, [html]);

    const looksLikeHtml = useMemo(() => /<\/?[a-z][\s\S]*>/i.test(String(html || '')), [html]);

    if (!looksLikeHtml) {
        return <div className={`whitespace-pre-wrap ${className}`} data-testid={dataTestId}>{html}</div>;
    }

    return (
        <div
            className={`prose prose-sm max-w-none prose-a:text-primary prose-a:underline prose-img:rounded-lg ${className}`}
            data-testid={dataTestId}
            dangerouslySetInnerHTML={{ __html: clean }}
        />
    );
};

export default HtmlContent;
